import Vue from 'vue'
import isPresent from 'is-present'

const str2unix = (str)=>{
  return Math.trunc(Date.parse(str)/1000)
}
const add_unix = (res)=>{
  return res.object = res.object.map(el=>{
    el.updated_at_int = str2unix(el.updated_at)
    return el
  })
}

const set_unix = (arr)=>{
  for (const el of arr){
    el.updated_at_int = str2unix(el.updated_at)
  }
  return arr
}
const sortedUniqBy = (arr, attr)=>{
  const existing = new Set()
  return arr.sort((a,b)=>str2unix(b.updated_at)-str2unix(a.updated_at)).filter(obj=>{
    const key = obj[attr]
    if (existing.has(key)) return false
    existing.add(key)
    return true
  })
}

export default {
  namespaced: true,
  state: {
    cache: {},
  },
  mutations: {
    cache_promise(state, payload){
      state.cache[payload.key] = payload.data
    },
  },
  actions: {
    people_family({commit, state, rootState}, cached = true){
      if (rootState.current_org.id) return Promise.resolve([])
      if (state.cache.people_family && cached) return state.cache.people_family;

      const resp = Vue.axios.get(
        "/api2/auto/people/family",
        {params: {
            organization_id: rootState.current_org.id,
            include: ["address_relations","insurance_relations", "graduations", "relations", "custom_fields"]
          }}
      ).then(res=>{
        const people = res.data.object.map(person=>{
          person.updated_at_int      = str2unix(person.updated_at)
          if (person.weight_g)  person.weight_pounds = parseFloat((person.weight_g * 0.0022046).toFixed(2))
          if (person.height_mm) person.height_inches = Math.round(person.height_mm / 25.4)
          person.address_relations   = sortedUniqBy(person.address_relations, "address_id")
          person.insurance_relations = sortedUniqBy(person.insurance_relations, "insurance_id")
          person.relations           = sortedUniqBy(person.relations.filter(obj=>isPresent(obj.options)), "person_id")

          const graduation = person.graduations.sort((a,b)=>str2unix(b.updated_at) - str2unix(a.updated_at))[0]
          if (graduation){
            person.school_name = graduation.school_name
            person.school_type = graduation.school_type
            person.year        = graduation.year
            person.graduation_id = graduation.id
          }

          return person
        })

        return people
      }, _=>{return []})

      commit('cache_promise',{key: 'people_family', data: resp})
      return resp
    },
    people_addresses({commit, state, rootState}, cached = true){
      if (rootState.current_org.id) return []
      else if (state.cache.people_addresses && cached) return state.cache.people_addresses;

      const resp = Vue.axios.get(
        "/api2/auto/people/addresses",
        {params: { organization_id: rootState.current_org.id}}
      ).then(res=>{ return set_unix(res.data.object) }, _=>{return []})

      commit('cache_promise',{key: 'people_addresses', data: resp})
      return resp
    },
    people_doctors({commit, state, rootState}, cached = true){
      if (rootState.current_org.id) return []
      else if(state.cache.people_doctors && cached) return state.cache.people_doctors

      const resp = Vue.axios.get(
        "/api2/auto/people/doctors",
        {params: { organization_id: rootState.current_org.id}}
      ).then(res=>{ return set_unix(res.data.object) }, _=>{return []})

      commit('cache_promise',{key: 'people_doctors', data: resp})
      return resp
    },

    people_emergencies({commit, state, rootState}, cached = true){
      if (rootState.current_org.id) return []
      else if(state.cache.emergencies && cached) return state.cache.emergencies

      const resp = Vue.axios.get(
        "/api2/auto/people/emergencies",
        {params: { organization_id: rootState.current_org.id}}
      ).then(res=>{ return set_unix(res.data.object) }, _=>{return []})

      commit('cache_promise',{key: 'emergencies', data: resp})
      return resp
    },

    people_insurances({commit, state, rootState}, cached = true){
      if(rootState.current_org.id)           return []
      else if(state.cache.people_insurances && cached) return state.cache.people_insurances

      const resp = Vue.axios.get(`/api2/auto/people/insurances`, {params: {
          organization_id: rootState.current_org.id
        }})
        .then(out=>out.data, ()=>[])
        .then(add_unix)

      state.cache.people_insurances = resp
      return resp
    },

    people_medications({commit, state, rootState}, cached = true){
      const per_id = rootState.current_reg.person_id
      if(rootState.current_org.id || !per_id || per_id===-1) return Promise.resolve([])
      if(!state.cache.people_medications) state.cache.people_medications = {}
      if(state.cache.people_medications[per_id] && cached) return state.cache.people_medications[per_id]

      const resp = Vue.axios.get(`/api2/auto/people/${per_id}`, {params:{
          organization_id: rootState.current_org.id,
          include: ['medications']
        }}).then(out=>{
        return out.data.object.medications || []
      },()=>[])
      return state.cache.people_medications[per_id] = resp
    },
    person_concern({commit, state, rootState}, cached = true){
      const per_id = rootState.current_reg.person_id
      if (!per_id || per_id===-1) return Promise.resolve({})
      if(!state.cache.people_concerns) state.cache.people_concerns = {}
      if(state.cache.people_concerns[per_id] && cached) return state.cache.people_concerns[per_id]
      const resp = Vue.axios.get(`/api2/auto/people/${per_id}`,{params:{
          organization_id: rootState.current_org.id,
          include: ['person_concern']
        }}).then(resp=>resp.data.object.person_concern || {},()=>({}))
      return state.cache.people_concerns[per_id] = resp
    },

    async people_countries({}){
      const key = "fid_countries_3"
      if(window.localStorage.getItem(key)) return JSON.parse(window.localStorage.getItem(key))

      const resp = (await Vue.axios.get(`/api2/family/countries`, {params: {per: 300}})).data.object;

      let ca_id=null, us_id=null;
      for (let i=0;i<resp.length;i++){
        const item = resp[i]
        resp[i].name = I18n.t(`app.countries.${item.code}`, {default: item.name})
        if(resp[i].code === 'CA') ca_id = resp[i].id
        else if(resp[i].code === 'US') us_id = resp[i].id
      }
      resp.unshift({code: "-",  name: "--------------", id: -1, disabled: true})
      resp.unshift({code: "CA", name: I18n.t('app.countries.CA'), id: ca_id})
      resp.unshift({code: "US", name: I18n.t('app.countries.US'), id: us_id})

      window.localStorage.setItem(key, JSON.stringify(resp))
      return resp
    },
  }
}
